import React from "react";

export default function PerformanceConsolidationKpis({ kpis = {} }) {
    const formatScore = (val) => {
        if (val === null || val === undefined) return "—";
        return `${parseFloat(val).toFixed(2)}%`;
    };

    return (
        <div style={{ marginBottom: "24px" }}>
            <div className="perf-cons-kpis-grid perf-cons-kpis-grid--single-row">
                <div className="perf-cons-kpi-card highlight">
                    <span className="perf-cons-kpi-label">Collaborateurs</span>
                    <span className="perf-cons-kpi-val">{kpis.totalCollaborateurs || 0}</span>
                    <span className="perf-cons-kpi-subtext">Total eligibles</span>
                </div>

                <div className="perf-cons-kpi-card">
                    <span className="perf-cons-kpi-label">Non Demarres</span>
                    <span className="perf-cons-kpi-val">{kpis.notStartedCount || 0}</span>
                    <span className="perf-cons-kpi-subtext">
                        {kpis.totalCollaborateurs
                            ? ((kpis.notStartedCount / kpis.totalCollaborateurs) * 100).toFixed(0)
                            : 0}% du total
                    </span>
                </div>

                <div className="perf-cons-kpi-card info">
                    <span className="perf-cons-kpi-label">En Cours</span>
                    <span className="perf-cons-kpi-val">{kpis.inProgressCount || 0}</span>
                    <span className="perf-cons-kpi-subtext">
                        {kpis.totalCollaborateurs
                            ? ((kpis.inProgressCount / kpis.totalCollaborateurs) * 100).toFixed(0)
                            : 0}% du total
                    </span>
                </div>

                <div className="perf-cons-kpi-card warning">
                    <span className="perf-cons-kpi-label">En Attente Valid.</span>
                    <span className="perf-cons-kpi-val">{kpis.pendingValidationCount || 0}</span>
                    <span className="perf-cons-kpi-subtext">
                        {kpis.totalCollaborateurs
                            ? ((kpis.pendingValidationCount / kpis.totalCollaborateurs) * 100).toFixed(0)
                            : 0}% du total
                    </span>
                </div>

                <div className="perf-cons-kpi-card success">
                    <span className="perf-cons-kpi-label">Termines</span>
                    <span className="perf-cons-kpi-val">{kpis.completedCount || 0}</span>
                    <span className="perf-cons-kpi-subtext">
                        {kpis.totalCollaborateurs
                            ? ((kpis.completedCount / kpis.totalCollaborateurs) * 100).toFixed(0)
                            : 0}% du total
                    </span>
                </div>

                <div className="perf-cons-kpi-card info">
                    <span className="perf-cons-kpi-label">Progression Moyenne</span>
                    <span className="perf-cons-kpi-val" style={{ color: "#2563eb" }}>
                        {formatScore(kpis.progressionMoyenne)}
                    </span>
                    <div className="perf-progressbar" style={{ marginTop: "8px", height: "6px" }}>
                        <span style={{ width: `${kpis.progressionMoyenne || 0}%`, backgroundColor: "#2563eb" }}></span>
                    </div>
                </div>

                <div className="perf-cons-kpi-card highlight">
                    <span className="perf-cons-kpi-label">Score Global Moyen</span>
                    <span className="perf-cons-kpi-val" style={{ color: "#ee645f" }}>
                        {formatScore(kpis.scoreGlobalMoyen)}
                    </span>
                    <span className="perf-cons-kpi-subtext">Ponderation globale</span>
                </div>
            </div>
        </div>
    );
}
